import { Injectable } from '@angular/core';

type withIdentifier = {
    id: string;
};

@Injectable({
    providedIn: 'root',
})
export class SelectionService<T extends withIdentifier> {
    private selectedElement: Record<string, T> = {};
    private selectionIdSet = new Set<string>();

    public add(instance: T | T[]): void {
        if (Array.isArray(instance)) {
            instance.forEach((element: T) => {
                this.selectionIdSet.add(element.id);
                this.selectedElement[element.id] = element;
            });

            return;
        }

        this.selectionIdSet.add(instance.id);
        this.selectedElement[instance.id] = instance;
    }

    public has(instance: T | T[]): boolean {
        if (Array.isArray(instance)) {
            return instance.every((element: T) => this.selectionIdSet.has(element.id));
        }

        return this.selectionIdSet.has(instance.id);
    }

    public remove(instance: T | T[]): void {
        if (Array.isArray(instance)) {
            instance.forEach((element: T) => {
                this.selectionIdSet.delete(element.id);
                delete this.selectedElement[element.id];
            });

            return;
        }

        this.selectionIdSet.delete(instance.id);
        delete this.selectedElement[instance.id];
    }

    public reset(): void {
        this.selectedElement = {};
        this.selectionIdSet.clear();
    }
}
